<script>
import TenantRecipientsCard from '@/tenant/components/TenantRecipientsCard.vue';
import TenantReportingCard from '@/tenant/components/TenantReportingCard.vue';

export default {
  components: {
    TenantRecipientsCard,
    TenantReportingCard,
  },

  props: {
    configuration: { type: Object, required: true },
  },
}
</script>

<template>
  <div>

    <tenant-recipients-card
      :recipients="configuration.admin_recipients"
      @updated="$emit('updated', $event)" />

    <div class="mt-3"></div>

    <tenant-reporting-card
      :time-zone-id="configuration.reports_time_zone_id"
      @updated="$emit('updated', $event)" />

  </div>
</template>



// WEBPACK FOOTER //
// src/tenant/components/TenantConfiguration.vue